import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getHazardClasses = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/hazard-class`);
    return response.data;
  } catch (error) {
    console.error('Error fetching hazard classes:', error.response?.data || error);
    throw error;
  }
};

export const getHazardClassById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/hazard-class/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching hazard class:', error.response?.data || error);
    throw error;
  }
};

export const createHazardClass = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/hazard-class`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating hazard class:', error.response?.data || error);
    throw error;
  }
};

export const updateHazardClass = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/hazard-class/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating hazard class:', error.response?.data || error);
    throw error;
  }
};

export const deleteHazardClass = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/hazard-class/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting hazard class:', error.response?.data || error);
    throw error;
  }
};
